// removed by extract-text-webpack-plugin
module.exports = {"inner":"style__inner___3zvJp","icon":"style__icon___1Clro","iconMath":"style__iconMath___3rh_Z"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/spinner/style.css
// module id = 1126
// module chunks = 0